import { ErrorHandler, Injectable, Injector } from "@angular/core";

import { DEFAULT_NOTIFICATION_TIMEOUT_IN_MILLISECONDS } from "../services/notification/core/notification-core.service";
import { NotificationService } from "../services/notification/notification.service";
import { NotificationMessagePayload } from "../store/notification/notification.actions";
import { Code, Severity } from "../store/notification/notification.state";
import { Exception } from "../store/shared/http-request-state";

@Injectable()
export class CustomErrorHandler implements ErrorHandler {
  constructor(private injector: Injector) {}

  /**
   * In the future we could send those errors to ApplicationInsights or an other monitoring tool
   * to be able to react proactively.
   *
   * For now we are only displaying an error notification which allows us to catch unexpected errors as early as possible
   * and in the worst case if it happens in production the user can send us at least a print screen.
   */
  handleError(error: Exception | Error) {
    const notificationService = this.injector.get(NotificationService);

    const errorText =
      error instanceof Error
        ? this.createNotificationMessage(error)
        : this.createFallbackNotificationMessage(error);

    const notificationMessagePayload: NotificationMessagePayload = {
      code: Code.UNHANDLED_EXCEPTION,
      severity: Severity.ERROR,
      deleteAfterNextNavigation: false,
      deleteAfterNumberOfMilliseconds:
        DEFAULT_NOTIFICATION_TIMEOUT_IN_MILLISECONDS,
      text: errorText,
    };

    notificationService.createNotificationMessage(notificationMessagePayload);

    // We additionally also write the error to the console
    console.error(error);
  }

  private createNotificationMessage(error: Error) {
    return `${error.name}: ${error.message}`;
  }

  private createFallbackNotificationMessage(error: unknown) {
    return JSON.stringify(error);
  }
}
